import React from "react";
import {
  Badge,
  Box,
  Button,
  Divider,
  Group,
  Modal,
  NumberInput,
  Paper,
  SimpleGrid,
  Stack,
  Text,
  TextInput,
  Title,
} from "@mantine/core";

type IJordningGeneratorModalProps = {
  opened: boolean;
  onClose: () => void;
};

export const JordningGeneratorModal: React.FC<IJordningGeneratorModalProps> = ({
  opened,
  onClose,
}) => {
  return (
    <Modal opened={opened} onClose={onClose} title="Generer jordning" size="lg" centered>
      <Stack gap="md">
        <Paper
          withBorder
          radius="sm"
          p="xl"
          style={{
            borderStyle: "dashed",
            background: "var(--mantine-color-gray-0)",
            cursor: "default",
          }}
        >
          <Stack gap={6} align="center">
            <Title order={5}>Slipp SDOC her</Title>
            <Text size="sm" c="dimmed" ta="center">
              Last opp kundens jordingsstandard. Dokumentet skal senere tolkes av LLM.
            </Text>
            <Badge variant="light" color="gray">
              PDF, DOCX eller tekst
            </Badge>
          </Stack>
        </Paper>

        <Stack gap="xs">
          <Text fw={600} size="sm">
            Input fra SDOC
          </Text>
          <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="sm">
            <NumberInput
              label="Avstand fra transformator"
              value={1.5}
              suffix=" m"
              decimalScale={1}
              readOnly
            />
            <NumberInput
              label="Maskeavstand"
              value={0.8}
              suffix=" m"
              decimalScale={1}
              readOnly
            />
            <NumberInput
              label="Min. lederdybde"
              value={0.6}
              suffix=" m"
              decimalScale={1}
              readOnly
            />
            <TextInput label="Lederdimensjon" value="Cu 50 mm2" readOnly />
          </SimpleGrid>
        </Stack>

        <Divider />

        <Stack gap="xs">
          <Text fw={600} size="sm">
            Geometrisk inndata fra IFC
          </Text>
          <Box
            p="md"
            style={{
              border: "1px solid var(--mantine-color-gray-3)",
              borderRadius: 4,
              background: "var(--mantine-color-white)",
            }}
          >
            <Text size="sm" c="dimmed">
              Geometrisk inndata
            </Text>
          </Box>
        </Stack>

        <Group justify="flex-end">
          <Button variant="subtle" color="gray" onClick={onClose}>
            Avbryt
          </Button>
          <Button>Generer jordning</Button>
        </Group>
      </Stack>
    </Modal>
  );
};
